import Image from 'next/image'
import { cn } from '@/lib/utils'

interface BuddifyMarkProps {
  variant?: 'light' | 'dark' | 'auto'
  className?: string
}

export function BuddifyMark({ variant = 'auto', className }: BuddifyMarkProps) {
  return (
    <Image
      src="/logo.png"
      alt=""
      width={512}
      height={512}
      className={cn(
        'shrink-0 object-contain',
        variant === 'dark' && 'brightness-0 invert',
        variant === 'auto' && 'theme-logo-mark',
        className
      )}
    />
  )
}
